import { ApiResponse } from "../../../types/api";
import apiClient from "../../apiClient";
import {
  GetUsersParams,
  User,
  UsersResponse,
  CreateUserRequest,
  UpdateUserRequest,
} from "./type";

const USERS_ENDPOINT = "/users";

export const userService = {
  getUser: async (id: string): Promise<User> => {
    const response = await apiClient.get<ApiResponse<User>>(
      `${USERS_ENDPOINT}/${id}`,
    );
    return response.data.data;
  },

  getUsers: async (params: GetUsersParams = {}): Promise<UsersResponse> => {
    const searchParams = new URLSearchParams();

    if (params.skip !== undefined) {
      searchParams.append("skip", params.skip.toString());
    }
    if (params.limit !== undefined) {
      searchParams.append("limit", params.limit.toString());
    }
    if (params.role) {
      searchParams.append("role", params.role);
    }
    if (params.search) {
      searchParams.append("search", params.search);
    }

    const response = await apiClient.get<ApiResponse<UsersResponse>>(
      `${USERS_ENDPOINT}/?${searchParams.toString()}`,
    );
    return response.data.data;
  },

  createUser: async (userData: CreateUserRequest): Promise<User> => {
    const response = await apiClient.post<ApiResponse<User>>(
      USERS_ENDPOINT,
      userData,
    );
    return response.data.data;
  },

  updateUser: async (
    userId: string,
    userData: UpdateUserRequest,
  ): Promise<User> => {
    const response = await apiClient.put<ApiResponse<User>>(
      `${USERS_ENDPOINT}/${userId}`,
      userData,
    );
    return response.data.data;
  },

  deleteUser: async (userId: string): Promise<void> => {
    await apiClient.delete(`${USERS_ENDPOINT}/${userId}`);
  },
};

export type { User, CreateUserRequest, UpdateUserRequest };
